module.exports = function(obj) {
obj || (obj = {});
var __t, __p = '';
with (obj) {
__p += '<div class="wp-pagenavi" role="navigation">\r\n    <span class="pages">第 1 页，共 2 页</span>\r\n    <span aria-current="page" class="current">1</span>\r\n    <a class="page larger" title="第 2 页" href="https://hourtoglass.com/blog-center/page/2/">2</a>\r\n    <a class="nextpostslink" rel="next" aria-label="下一页" href="https://hourtoglass.com/blog-center/page/2/">\r\n        <span class="iconfont icon-a-11"></span>\r\n    </a>\r\n</div>';

}
return __p
}